import {
  getRootFoldersWithFilters,
  getSubFoldersWithFilters,
  getEntitiesWithFilters,
  getEntityWithFilters,
  searchEntitiesWithFilters,
  getMyRecentPickedEntities,
  getMyFavoriteEntities,
  getEntityPickerFolderById,
} from '@decisions/server/DecisionsFramework/ServiceLayer/Services/EntityPickerService';
import { EntityTypeInfo } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Folder/EntityTypeInfo';
import { EntityPickerItem } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/EntityPickerItem';
import { EntityPickerFolder } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/EntityPickerFolder';

interface IEpickDataProps {
  types?: EntityTypeInfo[];
  filterNames?: string[];
}

export const EpickTreeConstants = {
  allFoldersId: 'ALL_FOLDERS',
  recentItemsFolderId: 'RECENTS_FOLDER',
  favoriteItemsFolderId: 'FAVORITES_FOLDER',
  userDefinedTypesFolderId: 'USER_DEFINED_TYPES',
  allFoldersName: 'All',
  favoritesFolderName: 'Favorites',
  recentFolderName: 'Recent',
  userdefinedTypesFolderName: 'User Defined Types',
  currentFolderName: 'Current Folder',
  reportRootFolderId: 'DATA',
  reportRootFolderName: 'Data',
  calculatedFieldNodeName: 'Calculated Fields',
};

export interface IEntityPickerFetcher {
  fetchFolder: (id: string) => Promise<EntityPickerFolder>;
  fetchRootFolders: () => Promise<EntityPickerFolder[]>;
  fetchSubFolders: (folderId: string) => Promise<EntityPickerFolder[]>;
  fetchEntities: (folderId: string) => Promise<EntityPickerItem[]>;
  fetchEntity: (entityId: string) => Promise<EntityPickerItem>;
  searchEntities: (searchText: string, folderId?: string) => Promise<EntityPickerItem[]>;
  fetchEntitiesOfTypes: (types: EntityTypeInfo[]) => Promise<EntityPickerItem[]>;
  fetchFavorites: () => Promise<EntityPickerItem[]>;
  fetchRecentEntites: () => Promise<EntityPickerItem[]>;
}

export function entityPickerFetcher({ types, filterNames }: IEpickDataProps): IEntityPickerFetcher {
  const fetchFolder = async (id: string): Promise<EntityPickerFolder> => {
    return getEntityPickerFolderById({ folderId: id, loadIcon: true });
  };

  const fetchRootFolders = async (): Promise<EntityPickerFolder[]> => {
    return getRootFoldersWithFilters({ types, filterNames, loadIcon: true });
  };

  const fetchSubFolders = async (folderId: string): Promise<EntityPickerFolder[]> => {
    return getSubFoldersWithFilters({ types, folderId, filterNames, loadIcon: true });
  };

  const fetchEntities = async (folderId: string): Promise<EntityPickerItem[]> => {
    return getEntitiesWithFilters({ types, folderId, filterNames, loadIcon: true });
  };

  const fetchEntity = async (entityId: string): Promise<EntityPickerItem> => {
    return getEntityWithFilters({ entityId, filterNames, loadIcon: true });
  };

  const searchEntities = async (searchText: string, folderId?: string): Promise<EntityPickerItem[]> => {
    return searchEntitiesWithFilters({ types, folderId, textToSearch: searchText, filterNames, loadIcon: true });
  };

  const fetchEntitiesOfTypes = async (types: EntityTypeInfo[]): Promise<EntityPickerItem[]> => {
    return getEntitiesWithFilters({ types, filterNames, loadIcon: true });
  };

  const fetchFavorites = async (): Promise<EntityPickerItem[]> => {
    return getMyFavoriteEntities({ types, filterNames, loadIcon: true });
  };

  const fetchRecentEntites = async (): Promise<EntityPickerItem[]> => {
    return getMyRecentPickedEntities({ types, filterNames, loadThumbnail: false, loadIcon: true });
  };

  return {
    fetchEntities,
    fetchEntitiesOfTypes,
    fetchEntity,
    fetchFavorites,
    fetchFolder,
    fetchRecentEntites,
    fetchRootFolders,
    fetchSubFolders,
    searchEntities,
  };
}
